import { render, staticRenderFns } from "./Sagittarius.vue?vue&type=template&id=4a974a98"
import script from "./Sagittarius.vue?vue&type=script&lang=js"
export * from "./Sagittarius.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports